import React, { createContext, useContext } from 'react';
import type { CampaignTypes } from '../../types/campaign.types';


const CampaignTypeContext = createContext<CampaignTypes | undefined>(undefined);

export const CampaignTypeProvider: React.FC<{ type: CampaignTypes; children: React.ReactNode }> = ({ type, children }) => (
  <CampaignTypeContext.Provider value={type}>{children}</CampaignTypeContext.Provider>
);

export const useCampaignTypeContext = (): CampaignTypes => {
  const type = useContext(CampaignTypeContext);
  if (!type) {
    throw new Error('useCampaignTypeContext must be used within a CampaignTypeProvider');
  }
  return type;
};
